// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__21-MA","title":"Images45_title__21e08","images":"Images45_images__1ikDh"};